import {initializeApp} from "firebase/app";
import {getFirestore, doc, setDoc, getDoc} from "firebase/firestore";
import {updateDoc, deleteField} from "firebase/firestore";
import {useSelector} from "react-redux";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore();


export function setUserInfo(id, data) {
    const specialOfTheDay = doc(db, `users/${id}`);
    setDoc(specialOfTheDay, data, {merge: true});
}

export async function readUserData(id) {
    const specialOfTheDay = doc(db, `users/${id}`);
    const snapshot = await getDoc(specialOfTheDay);
    const userData = snapshot.data();
    return userData;
}


export async function deleteOrderServer(id) {
    const cityRef = doc(db, "users", id);
    await updateDoc(cityRef, {
        Order: deleteField(),
        ordersCount: deleteField()
    });
}
